import './main.css';
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

import { useNavigate } from "react-router-dom";
import logo from '../../images/logo.png'
import { Button, Input, message } from 'antd';

import callAPI from "../../comps/fetch/main";

function ResetPassword() {

    const [email, setEmail] = useState()
    const [loading, setLoading] = useState(false)
    const [messageApi, contextHolder] = message.useMessage();
    const navigate = useNavigate();

    const [getOTP, setGetOTP] = useState(0)

    const [otpState, setOTPState] = useState()

    const [resetPassword, setResetPassword] = useState()
    
    const [updatePassword, setUpdatePassword] = useState()

    const [callFinalReset, setCallFinalReset] = useState()

    const [timer, setTimer] = useState(30);

    const [ passwordResetState , setPasswordResetState] = useState()


    useEffect(() => {

        if (passwordResetState == undefined) {
            return
        }

        message.destroy()
        if(passwordResetState.code == 200){
            message.success("Password reset success.")
            message.success("Automatic logged in .")

            localStorage.setItem("token" , passwordResetState.data.token)
            sessionStorage.clear();
            localStorage.removeItem("refCode")
            localStorage.setItem("userData" , JSON.stringify(passwordResetState.data.data))
            navigate("/")
            return 
        }
        message.error(passwordResetState.message)
        setCallFinalReset()

    }, [passwordResetState])

    useEffect(() => {
        if (callFinalReset != true) {
            return
        }

        messageApi.loading("Please Wait, processing your request.")

        const apiURL = `/reset_password_validate?email_id=${email}`;
        callAPI({
            url: apiURL,
            method: "PUT",
            body: {...resetPassword, email_id : email},
            loadingState: setLoading,
            dataState: setPasswordResetState
        });

        
        setTimer(30)
    }, [callFinalReset])

    useEffect(() => {
        if (otpState == undefined || otpState == {}) {
            return
        }

        messageApi.open({ "content": otpState.message, "key": "otp-sent" })

        if(otpState?.code != 200){
            setOTPState(undefined)
        }
        
        setTimer(30)
    }, [otpState])

    useState(() => {

        if(updatePassword == undefined){
            return
        }

        const apiURL = `/reset_password_email?email_id=${email}`;
        callAPI({
            url: apiURL,
            method: "PUT",
            body: {},
            loadingState: setLoading,
            dataState: setOTPState
        });

    },[updatePassword])
    

useEffect(() => {
    if (getOTP < 1) {
        return;
    }

    if (getOTP > 0) {
        
        const intervalId = setInterval(() => {
            setTimer((prevTimer) => {
                if (prevTimer > 0) {
                    return prevTimer - 1;
                } else {
                    clearInterval(intervalId); // Clear interval when timer reaches 0
                    return 0; // Ensure it stops at 0
                }
            });
        }, 1000);

        setOTPState({});
        const apiURL = `/reset_password_email?email_id=${email}`;
        callAPI({
            url: apiURL,
            method: "PUT",
            body: {},
            loadingState: setLoading,
            dataState: setOTPState
        });

            return () => clearInterval(intervalId); // Clean up interval on component unmount
        }
    }, [getOTP]);


    useEffect(() => {

    } , [])
    return (
        <div className="account-setup rp-page">
            {contextHolder}
            <img src="/logo192.png"alt="Logo" style={{ height: '62px', width: '62px' }} />
            {otpState == undefined ? <div className="core-fb-rdr">
                <h1>Reset your password</h1>
                <p style={{ color: 'rgba(0,0,0,.40)' }}>Forgot your password? No worries, just reset your password!</p>
                <div style={{ marginTop: '20px' }}>
                    <Input placeholder='Please enter your registred email' size='large' value={email || ""} onChange={(e) => setEmail(e.target.value)} />
                    <Button onClick={() => { setGetOTP(getOTP + 1) }} style={{ marginTop: '20px' }} type='primary' size='large' loading={loading} block>Get OTP</Button>
                </div>
            </div> :

                <div className="core-fb-rdr">
                    <h1>Please Enter your otp & new password</h1>
                    <p style={{ color: 'rgba(0,0,0,.40)' }}>Forgot your password? No worries, just reset your password!</p>
                    <div style={{ marginTop: '20px' }}>
                        <h3>Please enter OTP</h3>
                        <Input.OTP length={6} placeholder='Please enter OTP' value={resetPassword?.otp || ""} size='large' onChange={(text) => setResetPassword({ ...resetPassword, "otp": text })} />
                        <h3>Please enter new password</h3>
                        <p style={{fontSize:'14px', opacity:'.5'}}>Suggestion : Minimum of 6 letters, includes symbols, numbers also.</p>
                        <Input.Password style={{ marginTop: '10px' }} placeholder='Please enter new password' size='large' onChange={(e) => setResetPassword({ ...resetPassword, "password": e.target.value })} />
                        <Button onClick={() => { setCallFinalReset(true) }} style={{ marginTop: '20px' }} type='primary' size='large' block loading={loading} >Update Password</Button>
                        {
                            timer === 0 ? <Button onClick={() => { setGetOTP(getOTP + 1) }} style={{ marginTop: '20px' }} size='large' loading={loading} block>Resend OTP</Button> : <p style={{marginTop:'10px', color:'rgba(0,0,0,.5)'}}>Resend OTP in {timer} seconds.</p>

                        }

                    <Button onClick={() => { setOTPState() }} style={{ marginTop: '20px' }} size='large' loading={loading} block>Change Email</Button>

                    </div>
                </div>
            }
        </div>
    )


}

export default ResetPassword;